/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Stat_SessionsInputs */

const en_hero_stat_sessions = /** @type {(inputs: Hero_Stat_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions coached`)
};

const pl_hero_stat_sessions = /** @type {(inputs: Hero_Stat_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeprowadzonych zajęć`)
};

/**
* | output |
* | --- |
* | "Sessions coached" |
*
* @param {Hero_Stat_SessionsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_stat_sessions = /** @type {((inputs?: Hero_Stat_SessionsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Stat_SessionsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_stat_sessions(inputs)
	return en_hero_stat_sessions(inputs)
});